// src/api/partage.ts — SCE Issues
// Retrouver un fichier ou un dossier SharePoint par son LIEN de partage
// (« Copier le lien ») : `/shares/u!…/driveItem`, sans ID de site ni de
// bibliothèque. Sorti de registreNcs.api le 07/10 pour le dossier des
// rapports FNC-T (rapportFnct.api).

/** `/shares/u!…` : l'adresse encodée en base64 « url-safe », préfixée `u!`. */
export function partage(url: string): string {
  const octets = new TextEncoder().encode(url)
  let binaire = ''
  for (const o of octets) binaire += String.fromCharCode(o)
  return `u!${btoa(binaire).replace(/=+$/, '').replace(/\//g, '_').replace(/\+/g, '-')}`
}
